import {Action} from "../../../action/action";
import type {MoveBookingState} from "../moveBookingState";
import type {MoveBookingDependencies} from "../moveBookingState.types";

export const SET_DEPENDENCIES = "SET_DEPENDENCIES";
export class SetDependencies extends Action<typeof SET_DEPENDENCIES, MoveBookingDependencies | undefined> {
  readonly type = SET_DEPENDENCIES;
  protected state: MoveBookingState;

  constructor(state: MoveBookingState, data?: MoveBookingDependencies | undefined) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    if (!this.data) return true;
    return this.isDoable();
  }

  public isDoable(): boolean {
    if (!this.data) return true;
    const {address, basisType, customerType, goal, service, partner} = this.data;
    const isRequiredValuesSet = this.allHasValues(address, basisType, customerType, goal, service, partner);
    return isRequiredValuesSet;
  }
}
